import zxcvbn from "zxcvbn";

// ZXCVBN docs:
// https://github.com/dropbox/zxcvbn

// ZXCVBN interactive utility:
// https://lowe.github.io/tryzxcvbn/

const dartmouthCustomDictionary = [
	"hello world",
	"dartmouth",
	"hanover",
	"go green",
	"new hampshire",
	"baker tower",
	"tuck!188",
	"dms_1997",
	"dart**04"
];

export default class DMS_1997 {

	static minLength = 8;
	static maxLength = 64;

	static checkPasswordQuality = (password, userRelatedCustomDictionary, minLength, maxLength) => {
		// handle null values
		password = password || "";

		// deny list is used in two ways
		// by passing to zxcvbn, it will affect score
		// we will directly check it ourselves
		const customDictionary = dartmouthCustomDictionary
			.concat(userRelatedCustomDictionary)
			.map(word => word.toLowerCase());

		const toTitleCase = word => word.charAt(0).toUpperCase() + word.slice(1);
		const checkSimpleCase = word =>
			word === word.toLowerCase() || word === word.toUpperCase() || word === toTitleCase(word);
		const isSimpleCase = checkSimpleCase(password);

		const result = zxcvbn(password, customDictionary);
		//console.log('zxvbn result');
		//console.log(result);

		/* 
			zxcvbn has six built-in word lists (in zxcvbn's frequency_lists file)
				passwords						30,000 common from breaches
				english_wikipedia				30,000 most common words in English Wikipedia
				female_names					3,712 common female names
				male_names						983 common male names
				surnames						10,000 common last names
				us_tv_and_film					19,160 words from some US TV & film corpus
		*/
		const corpusesToCheck = ["english_wikipedia", "us_tv_and_film"];

		/* 
		We want three things
			1) is it in standard English dictionary (common English word?)
			2) is it in our custom dictionary (roll into 'common password')
			3) is it a common password

		We are choosing to ignore other zxcvbn results:
			spatial, date, repeat, sequence
			We *could* consider using all of these
				but would need more detailed feedback to users
			zxcvbn's opinions will still be reflected in the result.score
				used by strength meter

		Is it in the standard English dictionary (? or common English word ?)
		We want to ignore zxcvbn cleverness like
				'in the dictionary backwards'
				'made up of three separate dictionary words'
				'made up of three separate dictinoary words backwards'
		We are implementing a simple 'is the case different enough'
			dictionary word: 		banana
			matching inputs:		[banana, Banana, BANANA]
			non-matching inputs:	[bananA, bANANA, bANaNa], anything else
		*/

		const isInDictionary =
			result.sequence
				.filter(x => corpusesToCheck.includes(x.dictionary_name))
				// l33t subsitutions are okay by us
				.filter(x => !x.l33t)
				// reversed dictionary words are okay by us
				.filter(x => !x.reversed)
				// sum of multiple dictionary words are okay by us - check if the returned token is the full password
				.filter(x => x.token.length === password.length).length > 0;

		// Is it in our custom dictionary
		const isInCustomDictionary = customDictionary.includes(password.toLowerCase());

		// Is it a common password
		const isCommonPassword =
			result.sequence
				.filter(x => x.dictionary_name === "passwords")
				// l33t subsitutions are okay by us
				.filter(x => !x.l33t)
				// reversed common passwords words are okay by us
				.filter(x => !x.reversed)
				// sum of multiple common passwords are okay by us
				.filter(x => x.token.length === password.length).length > 0;

		const simpleResult = {
			adequateLength: password.length >= minLength,
			minLength: minLength,
			maxLength: maxLength,
			dictionaryWord: isInDictionary && isSimpleCase,
			commonPassword: (isCommonPassword || isInCustomDictionary) && isSimpleCase,
			score: result.score
		};

		return simpleResult;
	};
}
